import { useCallback, useEffect, useState } from "react";

import MonitorService, {
  MonitorEventByIdResponse,
} from "../api/MonitorService";
import { Job } from "../types/job";
import { MonitorEvent } from "../types/service";

export const useLastServices = (id?: string, pageSize?: number) => {
  const [lastServices, setLastServices] = useState<MonitorEvent[]>([]);
  const [lastServicesIncludes, setLastServicesIncludes] = useState<Job[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchLastServices = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    try {
      const result: MonitorEventByIdResponse =
        await MonitorService.GetMonitorLastServices(id, 1, pageSize ?? 1);

      if (result && Array.isArray(result.data)) {
        setLastServices(result.data ?? []);
        setLastServicesIncludes(result.includes?.job ?? []);
      } else {
        setLastServices([]);
        setLastServicesIncludes([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [id, pageSize]);

  useEffect(() => {
    fetchLastServices();
  }, [fetchLastServices]);

  return { lastServices, lastServicesIncludes, loading, fetchLastServices };
};
